<div *ngIf="showSelectAll" class="metadata-fields-action">
  <mat-slide-toggle [checked]="isSelectedAll" (change)="toggleSelectAll()">
    <span class="inner-text q9-section-data">{{ 'Select all' | translate }}</span>
  </mat-slide-toggle>
</div>

<div class="metadata-fields-area">
  <div class="metadata-fields-area--content" cdkDropListGroup>
    <div class="metadata-fields-area--content__container">
      <span>{{ availableItemsTitle | translate }}</span>

      <div
        class="metadata-fields-area--content__container--list"
        cdkDropList
        id="available-items-drop-list"
        [cdkDropListData]="filteredItems$ | async"
        (cdkDropListDropped)="drop($event)">
        <ng-container *ngIf="availableItems?.length">
          <div class="filtering-box">
            <mat-form-field class="q9-form-field filter-input" subscriptSizing="dynamic">
              <input
                matInput
                [placeholder]="filterPlaceholder | translate"
                [formControl]="control" />
              <q9-icon-button
                class="filter-clear-icon"
                *ngIf="control.value"
                (click)="resetFilter()"
                icon="close"
                [tooltip]="'RUBIC_CUBE.CLEAR_FILTER' | translate"></q9-icon-button>
            </mat-form-field>
          </div>
        </ng-container>

        <ng-container *ngFor="let item of (filteredItems$ | async)">
          <div
            class="metadata-fields-area--content__container--list__item"
            [ngClass]="{readonly: isReadonly}"
            (dblclick)="handleDblclick(item, container.AVAILABLE)"
            [cdkDragDisabled]="isReadonly"
            cdkDragPreviewClass="drag-preview"
            cdkDrag>
            {{ item | getDisplayValue: displayValueField | translate }}
          </div>
        </ng-container>
      </div>
    </div>

    <div class="metadata-fields-area--content__container">
      <span>{{ selectedItemsTitle | translate }}</span>

      <div
        class="metadata-fields-area--content__container--list"
        cdkDropList
        id="selected-items-drop-list"
        [cdkDropListData]="selectedItems"
        (cdkDropListDropped)="drop($event)">
        <ng-container *ngFor="let item of selectedItems">
          <ng-container *ngIf="!!item && !item.hide">
            <div
              class="metadata-fields-area--content__container--list__item"
              [ngClass]="{readonly: isReadonly}"
              (dblclick)="handleDblclick(item, container.SELECTED)"
              [cdkDragDisabled]="item?.locked || isReadonly"
              cdkDragBoundary=".column"
              cdkDragPreviewClass="drag-preview"
              cdkDrag>
              {{ item | getDisplayValue: displayValueField | translate }}
            </div>
          </ng-container>
        </ng-container>
      </div>
    </div>
  </div>
</div>
